class ProductAvailabilityPanel extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.abortController = new AbortController();
    const host = this.closest('.shopify-section, dialog');

    host?.addEventListener('shopify:product:select', this.handleProductSelect, {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  handleProductSelect = (event) => {
    if (event.target instanceof Element && event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const blockId = this.dataset.blockId;
        const selector = blockId
          ? `product-availability-panel[data-block-id="${CSS.escape(blockId)}"]`
          : 'product-availability-panel';
        const nextPanel = detail.html.querySelector(selector);

        if (!nextPanel) return;

        this.dataset.state = nextPanel.dataset.state || 'in_stock';
        this.toggleAttribute('hidden', nextPanel.hasAttribute('hidden'));
        this.innerHTML = nextPanel.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-availability] Variant update failed:', error);
      });
  };
}

if (!customElements.get('product-availability-panel')) {
  customElements.define('product-availability-panel', ProductAvailabilityPanel);
}
